// 英文
const en = {
    // 首页-激活说明
    activateExplain: {
        title: 'Activate Your Extended Warranty and Get the special gift for you',
        desp: 'Applied Condition: To qualify, customers agree to share their shopping experience with the purchased Our products that have been actively using for at least a week.',
        conditions: [
            'Only for customers that bought the products on Amazon.',
            'Each customer can only claim one FREE GIFT for one product. (Which means no matter how many times you purchase the same product, you can only get one FREE gift).',
        ]
    },
    // 首页-激活表单
    activateForm: {
        title: 'Activate Your Extended Warranty and Get the FREE gift NOW!',
        desp: 'Only Available to Existing Customers',
        name: 'Name',
        namePlaceholder: `Enter recipient's name`,
        nameErrMsg: `Name is incorrect.`,
        email: 'Email',
        emailPlaceholder: `Enter your email`,
        emailErrMsg: `Email is incorrect.`,
        verifCode: 'Verification Code',
        verifCodePlaceholder: `Enter your verification code`,
        verifCodeErrMsg: `Verification code is incorrect.`,
        btnSendCode: `SEND VERIFICATION CODE`,
        countdownMsg: `Resend after {countdown} seconds`,
        orderId: 'Order ID',
        orderIdPlaceholder: `Enter your order ID`,
        orderIdErrMsg: `Order ID is incorrect.`,
        orderAppliedError: `This order has already applied for a gift.`,
        skuAppliedError: `The gift of this order has been picked up.`,
        orderIdHelp: 'How to find your Order ID?',
        btnAactivate: 'ACTIVATE NOW',
        statement: 'We will certainly not share your personal information to others.',
        orderIdErrPopoverMsg: 'If your order ID is correct for sure, please contact our customer service by email. We will help you to activate the extended warranty and confirm whether the event covers your marketplace.',
        priceErrPopoverMsg: 'We are so sorry to tell you that this order has used our lowest discount, if any issues, welcome to email us.'
    },
    // 通用弹框
    commonModal: {
        msg: `{msg}`,
        msgContents: [
            `The recipient's name can not match the order`,
            `Whether Amazon's review is completed?`,
            `Would you like to continue to Amazon to review?`
        ],
        btnRewrite: 'REWRITE',
        btnNo: 'NO',
        btnYes: 'YES'
    },
    // 选择礼物
    chooseGift: {
        title: 'Now, Choose the gift you want.',
        modalTitle: 'Sorry, the gift you have selected is no longer available, please choose again',
        btnWant: 'I WANT IT',
        btnStockout: 'OUT OF STOCK'
    },
    // 订单信息
    orderInfo: {
        title: 'Congratulation! Your Extended Warranty is Activated!',
        desp: 'What You Will Get',
        orderTitle: 'Your Order Info',
        orderId: 'Order ID',
        productASIN: 'Product ASIN',
        productName: 'Product Title',
        address: 'Address',
        aboutGift: [
            'About the Gift',
            'NO shipping charges, NO hidden fees, NO credit card required.',
            '4 simple steps to get it (Less than 5 minutes).',
            'The gift will be sent to you in 2-5 working days after you claim it.'
        ],
        btnWant: 'I WANT IT'
    },
    // 步骤1
    stepOne: {
        title: 'Step 1 of 4: A Short Survey About Your Purchase.',
        questionList: [{
                id: 1,
                select_type: 'radio',
                name: 'sex',
                title: '1. I am a…?',
                option: [{
                        txt: 'Female',
                        value: 0
                    },
                    {
                        txt: 'Male',
                        value: 1
                    },
                    {
                        txt: 'Not Sure',
                        value: 2
                    }
                ]
            },
            {
                id: 2,
                select_type: 'radio',
                name: 'age',
                title: `2. What's your age range?`,
                option: [{
                        txt: 'Less than 20',
                        value: 0
                    },
                    {
                        txt: '20-30',
                        value: 1
                    },
                    {
                        txt: '30-40',
                        value: 2
                    },
                    {
                        txt: '40-50',
                        value: 3
                    },
                    {
                        txt: '50-60',
                        value: 4
                    },
                    {
                        txt: 'More than 60',
                        value: 5
                    }
                ]
            },
            {
                id: 3,
                select_type: 'radio',
                name: 'reason',
                title: '3. Why did you choose us?',
                option: [{
                        txt: 'Brand',
                        value: 0,
                    },
                    {
                        txt: 'Design',
                        value: 1
                    },
                    {
                        txt: 'Price',
                        value: 2
                    },
                    {
                        txt: 'Features',
                        value: 3
                    },
                    {
                        txt: 'Reviews',
                        value: 4
                    },
                    {
                        txt: 'Other Reasons',
                        value: 5,
                        placeholder: 'Please enter a reason'
                    }
                ]
            },
        ],
        btnNext: 'NEXT STEP'
    },
    // 步骤2
    stepTwo: {
        title: 'Step 2 of 4: Tell US Your Experience About the product.',
        despOne: `Overall rating?`,
        despTwo: `Let us know how our products are working for you.`,
        notice: `(Please enter at least 10 characters)`,
        commentPlaceholder: 'Enter your comment',
        commentErrMsg: `Comment words cannot exceed 20,000`,
        btnNext: 'NEXT STEP',
        btnPrev: 'PREV STEP'
    },
    // 步骤3
    stepThree: {
        title: 'Steps 3 of 4: Share Your Shopping Experience with Others.',
        desp: 'JUST takes you a few seconds. Your comments would help other customers to make a better shopping decision. Thanks for your understanding and support.',
        commentTitle: 'Your Comments',
        defaultComment: 'I like your product very much!',
        btnCopyPost: 'CLICK HERE TO COPY AND POST YOUR AMAZOM REVIEW'
    },
    // 步骤4
    stepFour: {
        title: 'Step 4 of 4: Confirm Your Address.',
        desp: 'What You Will Get',
        fullName: 'Full Name',
        fullNamePlaceholder: `Enter your full name`,
        fullNameErrMsg: `Full Name is incorrect`,
        phone: 'Phone',
        phonePlaceholder: `Enter your phone`,
        phoneErrMsg: `Phone is incorrect`,
        email: 'Email',
        emailPlaceholder: `Enter your email`,
        emailErrMsg: `Email is incorrect`,
        address: 'Address',
        addressPlaceholder: `Enter your address`,
        addressErrMsg: `Address is incorrect`,
        streetPlaceholder:`Street address`,
        apartmentPlaceholder:`Apartment/unit`,
        cityPlaceholder:`City`,
        regionPlaceholder: `Select State`,
        countryPlaceholder: `Select Country`,
        postcode: 'Postcode',
        postcodePlaceholder: `Enter your postcode`,
        postcodeErrMsg: `Postcode is incorrect`,
        btnComfirm: 'CONFIRM'
    },
    // 完成礼物申请
    completeApplication: {
        title: `You've finished the free gift application`,
        msgs: [
            'The free gift will be shipped in 2-5 working days.',
            'The free gift will be sent to your email ',
            ' in 2-5 working days.Sincerely thank you for purchasing our products, then there will be a dedicated after-sales team contact.',
            'Any further issues you may get, please contact with our customer service by email or visit our official website.',
            'Since you are not 100% satisfied with our products, you could contact with our customer service by email or visit our official website, there will be professionals to serve you. 100% customer satisfaction is our guarantee!'
        ],
        btnComfirm: 'CONFIRM'
    },
    // 获取订单号指导
    guide: {
        title: 'How to find your order ID?',
        desps: [
            `Step 1: Login your Amazon account and click “Your Order” in Account & Lists Page`,
            `Step 2: Click “Order details” on the right order`,
            `Step 3: You will see your order ID`
        ],
        btnOK: 'OK'
    }
}

export default en